import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ModuleType } from '../../components/manageModule/types/moduleType';
export function useModuleDefaultValues() {
    const [searchParams] = useSearchParams();
    const moduleType = searchParams.get('moduleType');
    const paidModule = moduleType === ModuleType.PaidModule;
    const extra = moduleType === ModuleType.Extra || moduleType === ModuleType.PaidModule;
    const defaultValues = useMemo(() => ({
        classes: [],
        mediaId: null,
        imageId: null,
        coverImageId: null,
        cover: null,
        publicModule: false,
        extra,
        paidModule
    }), [extra, paidModule]);
    return defaultValues;
}
